// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1H2LC","label":"Completed_label__1gv5E"};